import { Appearance } from "@stripe/stripe-js";

/** Styles Stripe's Payment Element like the rest of the site (see styles/tokens.scss). */
const stripeAppearance: Appearance = {
  theme: "stripe",
  variables: {
    colorPrimary: "#141c27",
    colorText: "#141c27",
    colorTextSecondary: "#6d7280",
    colorBackground: "#ffffff",
    colorDanger: "#b3261e",
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    borderRadius: "10px",
    spacingUnit: "4px",
  },
  rules: {
    ".Input": {
      border: "1px solid #d4cdc0",
      boxShadow: "none",
    },
    ".Input:focus": {
      border: "1px solid #141c27",
      boxShadow: "0 0 0 3px rgba(20, 28, 39, 0.08)",
    },
    ".Tab": {
      border: "1px solid #e7e2d9",
      boxShadow: "none",
    },
    ".Tab--selected": {
      border: "1px solid #141c27",
    },
    ".Label": {
      fontSize: "12px",
      fontWeight: "600",
      letterSpacing: "0.08em",
      textTransform: "uppercase",
    },
  },
};

export default stripeAppearance;
